import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const FormTab = (props) => {
  function s(p) {
    return props.side + "." + p;
  }
  return (
    <SimpleShowLayout {...props}>
      <TextField source={s("season.team.name")} />
      <TextField source={s("id")} />
      <TextField source={s("football.id")} />
      <NumberInput source={s("football.totalPoints")} />
      <NumberInput source={s("football.firstQuarterPoints")} />
      <NumberInput source={s("football.secondQuarterPoints")} />
      <NumberInput source={s("football.thirdQuarterPoints")} />
      <NumberInput source={s("football.fourthQuarterPoints")} />
      <NumberInput source={s("football.overtimePoints")} />
      <NumberInput source={s("football.overtime2Points")} />
      <NumberInput source={s("football.overtime3Points")} />
      <NumberInput source={s("football.passingCompletions")} />
      <NumberInput source={s("football.passingAttempts")} />
      <NumberInput source={s("football.passingYards")} />
      <NumberInput source={s("football.passingTouchdowns")} />
      <NumberInput source={s("football.passingInterceptions")} />
      <NumberInput source={s("football.rushingAttempts")} />
      <NumberInput source={s("football.rushingYards")} />
      <NumberInput source={s("football.rushingTouchdowns")} />
      <NumberInput source={s("football.fumbles")} />
      <NumberInput source={s("football.fumblesLost")} />
      <NumberInput source={s("football.receptions")} />
      <NumberInput source={s("football.receivingYards")} />
      <NumberInput source={s("football.receivingTouchdowns")} />
      <NumberInput source={s("football.fieldGoalsMade")} />
      <NumberInput source={s("football.fieldGoalAttempts")} />
      <NumberInput source={s("football.pointAfterTouchdown")} />
      <NumberInput source={s("football.pointAfterTouchdownAttempts")} />
      <NumberInput source={s("football.pointAfterTouchdownsMade")} />
      <NumberInput source={s("football.interceptionTouchdowns")} />
      <NumberInput source={s("football.pointAfterTouchdownTwoPoints")} />
      <NumberInput source={s("football.returnTouchdowns")} />
      <NumberInput source={s("football.pointAfterTouchdownReturns")} />
      <NumberInput source={s("football.firstDowns")} />
      <NumberInput source={s("football.penalties")} />
      <NumberInput source={s("football.penaltyYards")} />
      <NumberInput source={s("football.pointsAllowed")} />
      <NumberInput source={s("football.puntingYards")} />
      <NumberInput source={s("football.punts")} />
      <NumberInput source={s("football.touchdownPasses")} />
      <NumberInput source={s("football.touchdownReceptions")} />
      <NumberInput source={s("football.totalYards")} />
      <NumberInput source={s("football.yardsAllowed")} />
      <NumberInput source={s("football.puntingAverage")} />
      <NumberInput source={s("football.passingCompletionPercentage")} />
      <NumberInput source={s("football.passingInterceptionYards")} />
      <NumberInput source={s("football.passingAverage")} />
      <NumberInput source={s("football.rushingAverage")} />
      <NumberInput source={s("football.receivingAverage")} />
      <NumberInput source={s("football.fieldGoalYards")} />
    </SimpleShowLayout>
  );
};

export default FormTab;
